<button
    mat-icon-button
    attr.aria-label="{{
        'shared.skeleton.languageSelection.btnLabel' | translate
    }}"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    (click)="isOpen = true">
    <!-- 'alt' of the image is intentionally blank -> The purpose of the flags is just presentation logic,.
          For screen readers, there is an aria-label for each chip option -->
    <img
        src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
        [class]="
            'flag flag-' + mapLangToCountry(getCurrentLang()).toLowerCase()
        "
        [alt]="mapLangToCountry(getCurrentLang()).toLowerCase()"
        [attr.aria-label]="
            ('shared.skeleton.languageSelection.currenLanguageIs' | translate) +
            ('languages.' + getCurrentLang() | translate)
        " />
</button>
<apcam-language-select
    [languages]="availableLanguages"
    [(isOpen)]="isOpen"
    [trigger]="trigger"></apcam-language-select>
